/*
 * @Description: 仅提供给axios使用
 * @Date: 2024-11-05 09:46:11
 */

import { cloneDeep } from 'lodash';

/**
 * 将对象添加当作参数拼接到URL上面
 * @param baseUrl 需要拼接的url
 * @param obj 参数对象
 * @returns {string} 拼接后的对象
 * example:
 *  let obj = {a: '3', b: '4'}
 *  setObjToUrlParams('www.baidu.com', obj)
 *  ==>www.baidu.com?a=3&b=4
 */
export function setObjToUrlParams(baseUrl: string, obj: any): string {
  let parameters = '';
  let url = '';
  for (const key in obj) {
    parameters += key + '=' + encodeURIComponent(obj[key]) + '&';
  }
  parameters = parameters.replace(/&$/, '');
  if (/\?$/.test(baseUrl)) {
    url = baseUrl + parameters;
  } else {
    url = baseUrl.replace(/\/?$/, '?') + parameters;
  }
  return url;
}

/**
 * @description: 添加参数到对应的path(url params)
 * @param {string} url
 * @param {object} data
 * @return {object} 返回格式化后的 URL 和更新后的 data 对象
 * example:
    const url = '/api/:id/list/:detailId';
    const data = { id: 1, detailId: 2, name: 'example' };
    try {
      const result = formatUrlAndFilterData(url, data);
      console.log(result.url); // 输出：'/api/1/list/2'
      console.log(result.data); // 输出：{ name: 'example' }
    } catch (error) {
      console.error(error.message); // 若缺少参数会输出错误信息
    }
 */

export function formatParamsToPath(url, data) {
  const _data = cloneDeep(data);
  // 使用正则表达式匹配 URL 中的参数
  const newUrl = url.replace(/:(\w+)/g, (_, key) => {
    if (!(key in _data)) {
      throw new Error(`Missing required parameter: ${key}`);
    }
    // 将 URL 中的 ":param"  替换为 data 对象中对应的值
    const value = _data[key];
    // 删除 data 对象中已使用的属性
    delete _data[key];
    return value;
  });
  return { url: newUrl, data: _data };
}

export const getFileNameFromUrl = (url: string): string => {
  const parsedUrl = new URL(url);
  const pathname = parsedUrl.pathname;
  const lastSlashIndex = pathname.lastIndexOf('/');
  const fileName = pathname.substring(lastSlashIndex + 1) || '下载文件';
  return decodeURIComponent(fileName);
};
